<template>
    <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          v-bind="props"
          class="text-none mb-7"
          size="x-large"
          variant="flat"
          :disabled="disabled"
        >
          {{ buttonLabel }}
          <v-icon dark>
            mdi-menu-down
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="item in listItems" :key="item.value" @click="handleClick(item.value)" :disabled="disableCondition(item)">
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </template>
  
  <script>
import { Dropdown } from 'bootstrap';

  export default {
    props: {
      buttonLabel: String,
      listItems: Array,
      DropdownAction: Function,
      disabled: Boolean,
      disableCondition:Function
    },
    methods: {
    handleClick(value) {
      this.DropdownAction(value);
    },
      
  }
  }
  </script>
  
  <style scoped>
  /* Add any component-specific styles here */
  </style>